import * as React from 'react';
import * as styles from './styles.css';
import { Spinner } from '@cian/ui-kit';
import cn from 'classnames';
import { useIsDesktop } from '../../../../../utils/useIsDesktop';

export interface IContentLoadingProps {
  isLoading?: boolean;
}

export const ContentLoading: React.FC<IContentLoadingProps & React.PropsWithChildren> = props => {
  const { children, isLoading } = props;
  const isDesktop = useIsDesktop();

  if (!isLoading) {
    // oxlint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return (
    <div className={cn(styles['preloader'], { [styles['preloader-mobile']]: !isDesktop })}>
      <Spinner size={isDesktop ? 44 : 32} />
    </div>
  );
};

ContentLoading.displayName = 'ContentLoading';
